import { useEffect, useMemo } from 'react';

import { useGameStateSlice } from '@pp/core/src/store/slices/game/selectors';
import { gameStateActions } from '@pp/core/src/store/slices/game/slice';

import { useGameDispatch } from '../../store/GameStore';
import { useHighflyerStateSlice } from '../../store/slices/highflyerState/selectors';
import { winStates } from '../../store/slices/highflyerState/types';

export const useWinAmount = (): { winState: winStates; amount: number; playWinSound: boolean } => {
  const cashOutObj = useHighflyerStateSlice.getCashedObj();
  const winResult = useGameStateSlice.winResult();
  const winState = useHighflyerStateSlice.getWinState();
  const dispatch = useGameDispatch();
  const isMegaWin = useHighflyerStateSlice.isMegaWin();

  useEffect(() => {
    if (winState === winStates.youWin) {
      const winAmount = Object.values(cashOutObj).reduce((total, _) => total + _, 0);
      dispatch(gameStateActions.setWinResult({ amount: winAmount, updateTimestamp: Date.now(), isMegaWin: isMegaWin }));
    }
  }, [winState, cashOutObj, dispatch, isMegaWin]);

  return useMemo(() => {
    let winAmount = Object.values(cashOutObj).reduce((total, _) => total + _, 0);
    let playWinSound = true;
    if (winResult && winResult?.amount > 0) {
      winAmount = winResult.amount;
      playWinSound = false;
    }
    return {
      winState: winState,
      amount: winAmount,
      playWinSound: playWinSound,
    };
  }, [cashOutObj, winResult, winState]);
};
